module.exports = __webpack_public_path__ + "static/img/code.a803cb34.jpg";